<template>
    <div class="widget-sorting-params">
        <div class="mb-4">
            <VcRadioButtonsGroup
                v-model="sortingOrderModel"
                :radios="sortingOrderOptions"
                :config="{ valueKey: 'value', labelKey: 'label' }"
            />
        </div>
        <div>
            <VcSelect
                v-model="sortingPropModel"
                :options="propsList"
                :config="{ valueKey: 'value', labelKey: 'label' }"
                :multiple="false"
                :filterable="true"
                class="w-full max-w-full"
            />
        </div>
    </div>
</template>

<script setup lang="ts">
import { computed, onMounted, ref } from 'vue'
import { SortingParams, WidgetTemplateColumn } from '@/types/dashboard'
import { getTranslationOrUndefined } from '@/helpers/translation'
import startCase from 'lodash/startCase'
import { useI18n } from 'vue-i18n'
import { VcRadioButtonsGroup, VcSelect } from '@voicenter-team/voicenter-ui-plus'

const { t } = useI18n()

const ASC_SORTING = 'ascending'
const DESC_SORTING = 'descending'

type TPropsList = { label: string, value: string }

const props = defineProps<{
    modelValue: SortingParams
    templateColumns?: Array<WidgetTemplateColumn>
}>()

const sortingOrderOptions = computed(() => [
    {
        label: t('sorting.asc'),
        value: ASC_SORTING
    },
    {
        label: t('sorting.desc'),
        value: DESC_SORTING
    }
])

const emit = defineEmits<{
    (e: 'update:modelValue', v: SortingParams): void
}>()

const propsList = ref<Array<TPropsList>>([])

const sortingOrderModel = computed({
    get () {
        return props.modelValue?.order
    },
    set (val) {
        emit('update:modelValue', {
            ...props.modelValue,
            order: val
        })
    }
})
const sortingPropModel = computed({
    get () {
        return props.modelValue?.prop
    },
    set (val) {
        emit('update:modelValue', {
            ...props.modelValue,
            prop: val
        })
    }
})


function initSortingParams () {
    sortingPropModel.value = props.modelValue?.prop ?? ''

    if (props.modelValue?.order) {
        sortingOrderModel.value = props.modelValue.order
    }

    if (!props.templateColumns) {
        propsList.value = []
        return
    }
    const _list: Array<TPropsList> = []
    props.templateColumns.forEach(column => {
        const label = getTranslationOrUndefined(column.TemplateNameContentTag)
            || getTranslationOrUndefined(column.WidgetTemplateColumnsName)
            || startCase(column.WidgetTemplateColumnsName)

        _list.push({
            label: `${label}`,
            value: column.WidgetTemplateColumnsTag
        })
    })
    propsList.value = [ ..._list ]
}

onMounted(initSortingParams)
</script>
